export const DYNAMIC_ROUTES_CONSTANT = {
  ACCESS_CODE: ":accessCode",
  INTERVIEW_SLUG: ":interviewSlug",
  QUESTION_SLUG: ":questionSlug",
  SSO_ACCESS_CODE: ":ssoAccessCode",
  ACCESS_TOKEN_CODE: ":accessTokenCode",
};

export const RELATIVE_ROUTES = {
  ACCESS_ROUTE: `/gateway/${DYNAMIC_ROUTES_CONSTANT.ACCESS_CODE}`,
  ADD_QUESTION_ROUTE: "add-question",
  BASE_ROUTE: "/",
  CANDIDATE_LOGIN_ROUTE: "login",
  CANDIDATE_WAIT_ROUTE: "wait",
  DOSELECT_FEEDBACK_ROUTE: "feedback",
  DOSELECT_FEEDBACK_REVISION_ROUTE: "feedback-revision",
  IMPORT_QUESTION_ROUTE: "import-question",
  INTERVIEW_FEEDBACK_ROUTE: "interview-feedback",
  INTERVIEW_FEEDBACK_REVISION_ROUTE: "interview-feedback-revision",
  INTERVIEW_ROUTE: `/interview/${DYNAMIC_ROUTES_CONSTANT.INTERVIEW_SLUG}`,
  NOT_FOUND_ROUTE: "not-found",
  QUESTION_ROUTE: `question/${DYNAMIC_ROUTES_CONSTANT.QUESTION_SLUG}`,
  CREATED_IMPORT_QUESTIONS_ROUTE: `question/${DYNAMIC_ROUTES_CONSTANT.QUESTION_SLUG}/import-question`,
  REDIRECTION_ROUTE: "redirect",
  SSO_AUTH_ROUTE: `/ssoauth/${DYNAMIC_ROUTES_CONSTANT.SSO_ACCESS_CODE}`,
  ACCESS_TOKEN_AUTH_ROUTE: `/auth/${DYNAMIC_ROUTES_CONSTANT.ACCESS_TOKEN_CODE}`,
  STAR_ROUTE: "*",
};

export const ROUTES = {
  ADD_QUESTION_ROUTE:
    RELATIVE_ROUTES.INTERVIEW_ROUTE +
    RELATIVE_ROUTES.BASE_ROUTE +
    RELATIVE_ROUTES.ADD_QUESTION_ROUTE,
  CREATED_IMPORT_QUESTIONS_ROUTE:
    RELATIVE_ROUTES.INTERVIEW_ROUTE +
    RELATIVE_ROUTES.BASE_ROUTE +
    RELATIVE_ROUTES.CREATED_IMPORT_QUESTIONS_ROUTE,
  CANDIDATE_LOGIN_ROUTE:
    RELATIVE_ROUTES.ACCESS_ROUTE +
    RELATIVE_ROUTES.BASE_ROUTE +
    RELATIVE_ROUTES.CANDIDATE_LOGIN_ROUTE,
  CANDIDATE_WAIT_ROUTE:
    RELATIVE_ROUTES.INTERVIEW_ROUTE +
    RELATIVE_ROUTES.BASE_ROUTE +
    RELATIVE_ROUTES.CANDIDATE_WAIT_ROUTE,
  DOSELECT_FEEDBACK_ROUTE:
    RELATIVE_ROUTES.INTERVIEW_ROUTE +
    RELATIVE_ROUTES.BASE_ROUTE +
    RELATIVE_ROUTES.DOSELECT_FEEDBACK_ROUTE,
  DOSELECT_FEEDBACK_REVISION_ROUTE:
    RELATIVE_ROUTES.INTERVIEW_ROUTE +
    RELATIVE_ROUTES.BASE_ROUTE +
    RELATIVE_ROUTES.DOSELECT_FEEDBACK_REVISION_ROUTE,
  IMPORT_QUESTION_ROUTE:
    RELATIVE_ROUTES.INTERVIEW_ROUTE +
    RELATIVE_ROUTES.BASE_ROUTE +
    RELATIVE_ROUTES.IMPORT_QUESTION_ROUTE,
  INTERVIEW_FEEDBACK_ROUTE:
    RELATIVE_ROUTES.INTERVIEW_ROUTE +
    RELATIVE_ROUTES.BASE_ROUTE +
    RELATIVE_ROUTES.INTERVIEW_FEEDBACK_ROUTE,
  INTERVIEW_FEEDBACK_REVISION_ROUTE:
    RELATIVE_ROUTES.INTERVIEW_ROUTE +
    RELATIVE_ROUTES.BASE_ROUTE +
    RELATIVE_ROUTES.INTERVIEW_FEEDBACK_REVISION_ROUTE,
  LANDING_ROUTE: RELATIVE_ROUTES.ACCESS_ROUTE,
  LOBBY_ROUTE: RELATIVE_ROUTES.INTERVIEW_ROUTE,
  NOT_FOUND_ROUTE: RELATIVE_ROUTES.BASE_ROUTE + RELATIVE_ROUTES.NOT_FOUND_ROUTE,
  QUESTION_ROUTE:
    RELATIVE_ROUTES.INTERVIEW_ROUTE +
    RELATIVE_ROUTES.BASE_ROUTE +
    RELATIVE_ROUTES.QUESTION_ROUTE,
  REDIRECTION_ROUTE:
    RELATIVE_ROUTES.ACCESS_ROUTE +
    RELATIVE_ROUTES.BASE_ROUTE +
    RELATIVE_ROUTES.REDIRECTION_ROUTE,
};

export const PRE_LOBBY_ROUTES = [
  ROUTES.LANDING_ROUTE,
  ROUTES.CANDIDATE_LOGIN_ROUTE,
  ROUTES.REDIRECTION_ROUTE,
];
